/* eslint-disable react/prop-types */
import React from "react";
import { FaCheck } from "react-icons/fa";
import withAlertModalContext from "./context";

const Success = ({ context }) => {
  const {
    data: {
      kinds_of_moment: kindsOfMoment,
      category,
      service_types: serviceTypes,
      country_codes: countryCodes,
    },
  } = context;

  return (
    <div className="b-inquiry-modal__step">
      <div className="b-inquiry-modal__header__title">
        <h1>{I18n.t("alert_modal.generic.settings")}</h1>
        <div className="b-alerts-modal__success-details">
          <p className="b-alerts-modal__success-description">
            <FaCheck size={18} className="b-alerts-modal__success-icon" />
            {I18n.t("alert_modal.success.active")}
          </p>
          <dl className="b-alerts-modal__success-details-list">
            <dt>{I18n.t("alert_modal.generic.kinds_of_moment")}:</dt>
            <dd>
              {kindsOfMoment
                .map((k) => I18n.t(`kinds_of_moment.${k}`))
                .join(", ")}
            </dd>

            <dt>{I18n.t("alert_modal.generic.category")}:</dt>
            <dd>{I18n.t(`categories.${category}`)}</dd>

            <dt>{I18n.t("alert_modal.generic.service_types")}:</dt>
            <dd>
              {serviceTypes.map((s) => I18n.t(`subtypes.${s}`)).join(", ")}
            </dd>

            <dt>{I18n.t("alert_modal.generic.countries")}:</dt>
            <dd>
              {countryCodes.map((c) => I18n.t(`country.${c}`)).join(", ")}
            </dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default withAlertModalContext(Success);
